import { render, staticRenderFns } from "./UnloadingCargo.vue?vue&type=template&id=5c6eca1c&"
import script from "./UnloadingCargo.vue?vue&type=script&lang=js&"
export * from "./UnloadingCargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports